export const BBC_ORDER_MANAGEMENT = {
    BBC_BOX_UPDATE: "BBC_BOX_UPDATE",
    BBC_BOX_UPDATE_SUCCESS: "BBC_BOX_UPDATE_SUCCESS",
    BBC_BOX_UPDATE_FAIL: "BBC_BOX_UPDATE_FAIL",

    GET_BBC_ORDERS_BY_TIME: "GET_BBC_ORDERS_BY_TIME",
    GET_BBC_ORDERS_BY_TIME_SUCCESS: "GET_BBC_ORDERS_BY_TIME_SUCCESS",
    GET_BBC_ORDERS_BY_TIME_FAIL: "GET_BBC_ORDERS_BY_TIME_FAIL"
}